import React from "react";
import { Card } from "primereact/card";

interface KpiTileProps {
  title: string;
  icon: string;
  value: string;
  suffix?: string;
  hint?: string;
  /** Renders the value as a quiet placeholder ("No data yet") rather than a figure. */
  muted?: boolean;
}

/** One headline figure on the analytics dashboard. */
const KpiTile: React.FC<KpiTileProps> = ({
  title,
  icon,
  value,
  suffix,
  hint,
  muted,
}) => (
  <Card className="shadow-2 h-full">
    <div className="flex align-items-center gap-2 mb-2">
      <i
        className={`pi ${icon} text-xl`}
        style={{ color: "var(--primary-color)" }}
      />
      <span className="text-500 font-medium text-sm">{title}</span>
    </div>
    <div
      className={`${muted ? "text-lg text-500" : "text-2xl font-bold text-900"}`}
    >
      {value}
      {suffix && !muted && (
        <span className="text-base font-normal text-500"> {suffix}</span>
      )}
    </div>
    {hint && <div className="text-sm text-500 mt-1">{hint}</div>}
  </Card>
);

export default KpiTile;
